import {
    Box,
    Menu,
    MenuItem,
    Tooltip,
    Typography,
} from '@mui/material';
import React, { useState } from 'react';
import styled from 'styled-components';

const DocumentContainer = ({ documents, edit = false, actionDelete }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedItem, setSelectedItem] = useState(null);

    const open = Boolean(anchorEl);

    const handleClick = (event, item) => {
        setAnchorEl(event.currentTarget);
        setSelectedItem(item);
    };

    const handleClose = () => {
        setAnchorEl(null);
        setSelectedItem(null);
    };

    const fileIcon = {
        pdf: 'fa-solid fa-file-pdf',
        xls: 'fa-solid fa-file-excel',
        xlsx: 'fa-solid fa-file-excel',
        doc: 'fa-solid fa-file-word',
        docx: 'fa-solid fa-file-word',
        pptx: 'fa-solid fa-file-powerpoint',
        pptm: 'fa-solid fa-file-powerpoint',
        ppt: 'fa-solid fa-file-powerpoint',
    };

    const fileColors = {
        pdf: '#E53935',
        xls: '#2E7D32',
        xlsx: '#2E7D32',
        doc: '#1565C0',
        docx: '#1565C0',
        ppt: '#EF6C00',
        pptx: '#EF6C00',
        pptm: '#EF6C00',
        default: '#757575',
    };

    const getFileColor = (type) => fileColors[type] || fileColors.default;

    const getFileLabel = (type) => {
        if (!type) return 'Archivo';
        return type.toUpperCase();
    };

    return (
        <>
            <DocumentsGrid>
                {documents?.map((item) => (
                    <Tooltip key={item?.uuid} title={item?.name} placement="top" arrow>
                        <DocumentCard>
                            {edit && (
                                <Box>
                                    <i
                                        className="options fas fa-ellipsis-v"
                                        onClick={(event) => handleClick(event, item)}
                                    />
                                </Box>
                            )}

                            <a
                                href={`${process.env.REACT_APP_BACK_URL}/${item?.path}`}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <Box
                                    className="icon-wrapper"
                                    sx={{
                                        backgroundColor: `${getFileColor(item?.type)}15`,
                                    }}
                                >
                                    <i
                                        className={
                                            fileIcon[item?.type] ?? 'fa-solid fa-file-lines'
                                        }
                                        style={{
                                            color: getFileColor(item?.type),
                                        }}
                                    />
                                </Box>

                                <Typography className="file-type">
                                    {getFileLabel(item?.type)}
                                </Typography>

                                <Typography className="file-name">
                                    {item?.name}
                                </Typography>

                                <Typography className="file-action">
                                    Ver documento
                                </Typography>
                            </a>
                        </DocumentCard>
                    </Tooltip>
                ))}
            </DocumentsGrid>

            <Menu
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >
                <MenuItem
                    onClick={() => {
                        handleClose();
                        actionDelete?.(selectedItem?.uuid);
                    }}
                >
                    Eliminar
                </MenuItem>
            </Menu>
        </>
    );
};

export default DocumentContainer;

const DocumentsGrid = styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
    gap: 12px;
`;

const DocumentCard = styled.div`
    position: relative;
    border-radius: 16px;
    background: #fff;
    border: 1px solid rgba(0, 0, 0, 0.06);
    overflow: hidden;
    transition: all 0.2s ease;
    min-height: 170px;

    &:hover {
        transform: translateY(-3px);
        box-shadow: 0 10px 22px rgba(0, 0, 0, 0.06);
    }

    i.options {
        position: absolute;
        top: 6px;
        right: 6px;
        cursor: pointer;
        color: #999;
        font-size: 0.8rem;
        border-radius: 50%;
        padding: 0.4rem 0.5rem;
        transition: all 0.2s ease;
        z-index: 10;

        &:hover {
            background: rgba(0, 0, 0, 0.06);
            color: #666;
        }
    }

    a {
        padding: 14px 12px;
        min-height: 170px;
        text-align: center;
        color: inherit;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-decoration: none;
    }

    .icon-wrapper {
        width: 60px;
        height: 60px;
        border-radius: 14px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 10px;
    }

    .icon-wrapper i {
        font-size: 2.4rem;
    }

    .file-type {
        font-size: 0.72rem;
        font-weight: 700;
        letter-spacing: 0.06em;
        color: #888;
        margin-bottom: 4px;
    }

    .file-name {
        width: 100%;
        font-size: 0.88rem;
        font-weight: 700;
        color: #222;
        line-height: 1.3;
        margin-bottom: 6px;

        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }

    .file-action {
        font-size: 0.78rem;
        font-weight: 600;
        color: #1976d2;
    }

    @media (max-width: 600px) {
        min-height: 150px;

        a {
            min-height: 150px;
            padding: 12px 10px;
        }

        .icon-wrapper {
            width: 52px;
            height: 52px;
        }

        .icon-wrapper i {
            font-size: 2rem;
        }

        .file-name {
            font-size: 0.82rem;
        }

        .file-action {
            font-size: 0.72rem;
        }
    }
`;